'use client';

import { useEffect, useContext, useState } from 'react';
import ErrorBoundary from '@sbt-web/error-boundary';
import { OptimizelySubitoContext } from '@sbt-web/houston-wrapper';
import { DeviceWidth } from '@sbt-web/ui';
import { WebVitalsLabProps } from './shared';
import CoreModule from './core';

const TOGGLE_NAME = 'it-subito-webvitals-lab';
const STORAGE_KEY = 'inp_lab';

const WebVitalsLab = ({ pageName }: WebVitalsLabProps) => {
  const { optimizely } = useContext(OptimizelySubitoContext);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const isMobile = window.matchMedia(
      `(max-width: ${DeviceWidth.mobile.max})`
    ).matches;

    // Monitor only msite
    if (!isMobile) {
      return;
    }

    // Activation via local storage
    if (localStorage.getItem(STORAGE_KEY) === 'y') {
      setEnabled(true);
      return;
    }

    // Activation via feature toggle
    if (optimizely) {
      optimizely.onReady().then(() => {
        const isToggleActive = optimizely.isFeatureEnabled(TOGGLE_NAME);
        const doesToggleEnablesThisPage = (
          optimizely.getFeatureVariableString(TOGGLE_NAME, 'pages') ?? ''
        )
          .split(',')
          .includes(pageName);

        if (isToggleActive && doesToggleEnablesThisPage) {
          setEnabled(true);
        }
      });
    }
  }, [optimizely]);

  if (enabled) {
    return <CoreModule pageName={pageName} />;
  }
};

export const SafeWebVitalsLab = (props: WebVitalsLabProps) => {
  return (
    <ErrorBoundary>
      <WebVitalsLab {...props} />
    </ErrorBoundary>
  );
};

export { SafeWebVitalsLab as WebVitalsLab, TOGGLE_NAME };
